/**
 * App.jsx
 * Path: frontend/src/App.jsx
 * Description: Główny router aplikacji Teflis.
 * Related: context/AuthContext.js, pages/*.jsx
 */

import { Navigate, Route, Routes } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "./context/AuthContext";
import LoginPage from "./pages/LoginPage";
import CalendarPage from "./pages/CalendarPage";
import JobDetailPage from "./pages/JobDetailPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import ProtectedRoute from "./components/ProtectedRoute";

export default function App() {
  const { hydrated, user } = useContext(AuthContext);

  if (!hydrated) {
    return <div className="screen-center">Ładowanie aplikacji...</div>;
  }

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/calendar" replace /> : <LoginPage />} />
      <Route
        path="/calendar"
        element={
          <ProtectedRoute>
            <CalendarPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/jobs/:id"
        element={
          <ProtectedRoute>
            <JobDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/users"
        element={
          <ProtectedRoute adminOnly>
            <AdminUsersPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to={user ? "/calendar" : "/login"} replace />} />
    </Routes>
  );
}

